import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=cfc32b7a&"
import script from "./UploadImageModal.vue?vue&type=script&lang=ts&"
export * from "./UploadImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImageModal.vue?vue&type=style&index=0&id=cfc32b7a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports